import {connect} from 'react-redux';
import {compose} from 'redux';
import { createStructuredSelector } from 'reselect';

import { selectIsCollectionLoaded} from '../../redux/shop/shop-selector';
import withSpinner from '../../Components/with-spinner/with-spinner-component';
import CollectionPage from './collection-component';

const mapStateToProps = createStructuredSelector({
    isLoading: state => !selectIsCollectionLoaded(state)
});

const CollectionPageContainer =compose (
    connect(mapStateToProps),
    withSpinner
)(CollectionPage);

export default CollectionPageContainer;
